import { render, staticRenderFns } from "./SuccessRecoverMessage.vue?vue&type=template&id=6d84e752"
import script from "./SuccessRecoverMessage.vue?vue&type=script&lang=js"
export * from "./SuccessRecoverMessage.vue?vue&type=script&lang=js"
import style0 from "./SuccessRecoverMessage.vue?vue&type=style&index=0&id=6d84e752&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports